module.exports = __webpack_public_path__ + "static/media/surface_tension.17a386b7.jpg";